import React, { FC } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import './index.scss';
import img from 'style/imgs/forgotimg.png';
import closeIcon from 'style/imgs/icons/close-icon.svg';
import buttons from 'style/buttons.module.scss';
import { IAuthData } from 'types';
import { sendResetPasswordCode } from 'actions/auth';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RadiusInput from '../formElements/radiusInput';
import Form from '../formElements/form';

interface PasswordProps {
  modalOpen: () => void;
}

const ForgotPassword: FC<PasswordProps> = ({ modalOpen }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const schema = yup.object().shape({
    email: yup.string().email().required(),
  });

  const { register, handleSubmit, errors } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (values: IAuthData) => {
    await dispatch(sendResetPasswordCode(values.email));
    history.push({
      pathname: '/send-email',
      state: { email: values.email },
    });
  };

  return (
    <div>
      <div className="password-form">
        <div
          role="button"
          tabIndex={0}
          className="btn-close"
          onKeyDown={modalOpen}
          onClick={modalOpen}
        >
          <img src={closeIcon} alt="" />
        </div>
        <div className="password-form__decoration">
          <img src={img} alt="" />
        </div>
        <div className="password-form__title">Forgot Password?</div>
        <div className="password-form__description">Please enter email.</div>
        <Form id="form-2" onSubmit={handleSubmit(onSubmit)}>
          <RadiusInput
            variant="outlined"
            type="text"
            label="Your email"
            name="email"
            ref={register}
            error={!!errors.email}
          />
          <button type="submit" className={buttons.buttomPrimary}>
            Submit
          </button>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
